<template>
  <div ref="rootDir" class="fixed top-0 left-0 w-full z-50 overflow-hidden animate__animated animate__fadeIn animate__faster">
    <section class="lg:grid grid-flow-col min-h-screen w-screen overflow-auto max-h-full">
      <div class="h-screen flex flex-row lg:col-span-10 bg-secondary-light">
        <AppMenuList class="grow" />
        <div class="absolute right-0 top-0 lg:relative lg:bg-secondary-light px-6 lg:px-20 pt-6">
          <UtilityButton
            is-button
            class="bg-secondary hover:bg-primary transition-colors !text-primary hover:!text-white duration-150 !p-4"
            @click="closeNavigation"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
            <span class="sr-only">Zatvoriť navigačné menu</span>
          </UtilityButton>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup lang="ts">
import 'animate.css'

const openNavigation = useOpenNavigation()
const rootDir = ref<HTMLElement>()

const closeNavigation = () => {
  rootDir.value?.classList?.replace('animate__fadeIn', 'animate__fadeOut')
  setTimeout(() => {
    openNavigation.value = false
  }, 500)
}

useHead({
  htmlAttrs: {
    class: 'overflow-hidden',
  },
})
</script>
